<template>
  <div v-if="showFields">
    <div class="field">
      <!-- <TextInput v-model="ObjServiceType.pocode" placeholder=" " :requiredIcon="false" clearable name="PackID"
                id="PackID" label="Code" :rules="{ required: false }" /> -->
      <label>Code</label>
      <CustomAutoComplete
        name="Code"
        id="Code"
        v-model="ObjServiceType.pocode"
        :items="options.fromsCodearray"
        @item-select="passdata"
        :required-icon="true"
        :rules="{ required: true, alphanumeric: true }"
      />
    </div>
    <div class="field" v-if="poidfield">
      <TextInput
        v-model="ObjServiceType.poid"
        placeholder=" "
        :requiredIcon="false"
        clearable
        name="pocode"
        id="pocode"
        :label="type === 1 ? 'Po Code' : 'Pi Code'"
        :rules="{ required: false }"
      />
    </div>
    <div class="field">
      <MultiSelectDropdown
        label="Supplier Name"
        v-model="ObjServiceType.suppliername"
        :items="options.suppliernamearray"
        @update:modelValue="updatedSupplier"
      />
    </div>
  </div>
  <div class="field" v-if="StatusFilter.Status">
    <MultiSelectDropdown
      label="Status"
      v-model="ObjStatusAndApproval.Status"
      :items="StatusArray"
      @update:modelValue="StatusOnChange"
    />
  </div>

  <!-- <div class="field" v-if="StatusFilter.Status && StatusFilter.StatusFrom == 'PO'">
        <MultiSelectDropdown label="Status" v-model="ObjStatusAndApproval.Status" :items="POStatusArray"
            @update:modelValue="StatusOnChange" />
    </div>

    <div class="field" v-if="StatusFilter.Status && StatusFilter.StatusFrom == 'Req'">
        <MultiSelectDropdown label="Status" v-model="ObjStatusAndApproval.Status" :items="RequestStatusArray"
            @update:modelValue="StatusOnChange" />
    </div>

    <div class="field" v-if="from === 'poAm'">
        <MultiSelectDropdown label="Status" v-model="ObjStatusAndApproval.Status" :items="POAmendmentStatusArray"
            @update:modelValue="StatusOnChange" />
    </div>

    <div class="field" v-if="from === 'pr'">
        <MultiSelectDropdown label="Status" v-model="ObjStatusAndApproval.Status" :items="PRStatusArray"
            @update:modelValue="StatusOnChange" />
    </div> -->

  <div class="field" v-if="StatusFilter.AprrovalStatus">
    <MultiSelectDropdown
      label="Approval Status"
      :items="ApprovalStatusArray"
      v-model="ObjStatusAndApproval.ApprovalStatus"
      @update:modelValue="ApprovalStatusOnChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import MultiSelectDropdown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import service from "../../../../modules/Inventory/Service/SupplierMaster";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import { boolean } from "yup";
import CustomAutoComplete from "../../../../components/FormComponents/AutoComplete.vue";

export default defineComponent({
  components: {
    MultiSelectDropdown,
    TextInput,
    CustomAutoComplete,
  },
  props: {
    removechiptype: {
      type: Number,
      default: 0,
    },

    poidfield: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
    },

    showFields: {
      type: Boolean,
      default: true,
    },

    StatusFilter: {
      type: Object,
      default: {},
    },
    resetfilter: {
      type: Boolean,
      default: false,
    },
    itemsList: {
      type: Array,
      default: [],
    },
  },

  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const ObjServiceType = ref({
      pocode: ref(),
      suppliername: ref(),
      poid: ref(),
    });

    const ObjStatusAndApproval = ref({
      Status: ref(),
      ApprovalStatus: ref(),
      SupplierNames: ref(""),
      SupplierIds: ref(""),
      StatusNames: ref(""),
      StatusIds: ref(""),
      ApprovalStatusNames: ref(""),
      ApprovalStatusIds: ref(""),
    });

    let options: any = ref({
      pocodearray: [],
      suppliernamearray: [],
    });

    const ApprovalStatusArray = ref([
      { name: "Pending", value: "0" },
      { name: "Approved", value: "1" },
      { name: "Declined", value: "3" },
    ]);

    const StatusArray = ref([
      { name: "Draft", value: "6", IsDraft: "1", FilterKey: "PO" },
      { name: "Pending", value: "0", IsDraft: "0", FilterKey: "PO" },
      { name: "Cancel PO", value: "4", IsDraft: "0", FilterKey: "PO" },
      {
        name: "Converted To PO Amendment",
        value: "1",
        IsDraft: "0",
        FilterKey: "PO",
      },
      {
        name: "Converted To GRN Completed",
        value: "2",
        IsDraft: "0",
        FilterKey: "PO",
      },
      {
        name: "Converted To GRN Partially",
        value: "3",
        IsDraft: "0",
        FilterKey: "PO",
      },
      {
        name: "Cancel PO Amendment",
        value: "5",
        IsDraft: "0",
        FilterKey: "PO",
      },

      { name: "Pending", value: "0", FilterKey: "InBReq" },
      { name: "Issued", value: "2", FilterKey: "InBReq" },
      { name: "Partially Converted to PR", value: "5", FilterKey: "InBReq" },
      { name: "Converted to PR", value: "4", FilterKey: "InBReq" },
      { name: "Issued Partially", value: "3", FilterKey: "InBReq" },
      { name: "Converted to PI", value: "1", FilterKey: "InBReq" },

      { name: "Pending", value: "0", FilterKey: "PR" },
      { name: "PO Partial", value: "2", FilterKey: "PR" },
      { name: "Converted to P0", value: "1", FilterKey: "PR" },

      { name: "Pending", value: "0", FilterKey: "POA" },
      { name: "Converted to GRN", value: "2", FilterKey: "POA" },
      { name: "Converted to P0 Ammendment", value: "1", FilterKey: "POA" },
    ]);

    StatusArray.value = StatusArray.value.filter(
      (x) => x.FilterKey == props.StatusFilter.StatusFrom
    );

    onMounted(() => {
      LoadSupplier();
    });

    watch(
      () => ObjServiceType.value.suppliername,
      (newVal) => {
        emit("suppliersename", ObjStatusAndApproval.value.SupplierNames);
        emit("supplierseid", ObjStatusAndApproval.value.SupplierIds);
      }
    );
    watch(
      () => props.resetfilter,
      (newVal) => {
        ObjServiceType.value.pocode = "";
        ObjServiceType.value.suppliername = "";
        ObjServiceType.value.poid = "";
        ObjStatusAndApproval.value.Status = "";
        ObjStatusAndApproval.value.ApprovalStatus = "";
      }
    );
    watch(
      () => props.StatusFilter.Status,
      (newVal) => {},
      { deep: true }
    );
    watch(
      () => ObjServiceType.value.pocode,
      (newVal) => {
        emit("updatedcode", ObjServiceType.value.pocode);
      }
    );

    watch(
      () => ObjServiceType.value.poid,
      (newVal) => {
        emit("updatedpoid", ObjServiceType.value.poid);
      }
    );

    watch(
      () => ObjStatusAndApproval.value.Status,
      (newVal) => {
        debugger;
        emit("StatusNames", ObjStatusAndApproval.value.StatusNames);
        emit("StatusIds", ObjStatusAndApproval.value.StatusIds);
      }
    );

    watch(
      () => ObjStatusAndApproval.value.ApprovalStatus,
      (newVal) => {
        debugger;
        emit(
          "ApprovalStatusName",
          ObjStatusAndApproval.value.ApprovalStatusNames
        );
        emit("ApprovalStatusIds", ObjStatusAndApproval.value.ApprovalStatusIds);
      }
    );

    const LoadSupplier = async () => {
      debugger;
      const response = await service.gettable();
      console.log(response["result"]);

      response["result"] = response["result"].filter((items) => {
        const branchIds =
          typeof usersData.BranchId === "string"
            ? usersData.BranchId.split(",").map(Number)
            : [usersData.BranchId];

        return (
          items.HospitalId == usersData.OrganizationId &&
          branchIds.includes(items.BranchId)
        );
      });

      options.value.suppliernamearray = response["result"].map((item) => {
        item.name = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    function updatedSupplier() {
      debugger;
      ObjStatusAndApproval.value.SupplierIds = "";
      const selectedValues = ObjServiceType.value.suppliername;

      if (selectedValues && Array.isArray(selectedValues)) {
        const selectedNames: any = [];
        const selectedIds: any = [];
        selectedValues.forEach((selectedValue) => {
          const selectedOption = options.value.suppliernamearray.find(
            (option) => option.value === selectedValue
          );
          const selectedIdOption = options.value.suppliernamearray.find(
            (option) => option.value === selectedValue
          );
          if (selectedOption) {
            const selectedName = selectedOption.Name;
            selectedNames.push(selectedName);
          }
          if (selectedIdOption) {
            const selectedName = selectedOption.Id;
            selectedIds.push(selectedName);
          }
        });
        console.log("Selected Names:", selectedNames.join(", "));
        if (selectedNames.length > 2) {
          ObjStatusAndApproval.value.SupplierNames =
            selectedNames.slice(0, 2).join(", ") + ", ...";
        } else {
          ObjStatusAndApproval.value.SupplierNames = selectedNames.join(", ");
        }
        if (selectedIds.length > 0) {
          ObjStatusAndApproval.value.SupplierIds = selectedIds.join(", ");
        }
        console.log(ObjStatusAndApproval.value.SupplierIds);
      }
    }

    function StatusOnChange() {
      debugger;
      ObjStatusAndApproval.value.StatusIds = "";
      const selectedValues = ObjStatusAndApproval.value.Status;
      if (selectedValues && Array.isArray(selectedValues)) {
        const selectedNames: any = [];
        const selectedIds: any = [];

        selectedValues.forEach((selectedValue) => {
          const selectedOption = StatusArray.value.find(
            (option) => option.value === selectedValue
          );
          const selectedIdOption = StatusArray.value.find(
            (option) => option.value === selectedValue
          );
          if (selectedOption) {
            const selectedName = selectedOption.name;
            selectedNames.push(selectedName);
          }
          if (selectedIdOption) {
            const selectedName = selectedOption?.value;
            selectedIds.push(selectedName);
          }
        });

        console.log("Selected Names:", selectedNames.join(", "));
        if (selectedNames.length > 2) {
          ObjStatusAndApproval.value.StatusNames =
            selectedNames.slice(0, 2).join(", ") + ", ...";
        } else {
          ObjStatusAndApproval.value.StatusNames = selectedNames.join(", ");
        }
        if (selectedIds.length > 0) {
          ObjStatusAndApproval.value.StatusIds = selectedIds.join(", ");
        }
        console.log(ObjStatusAndApproval.value.StatusIds);
      }
    }

    function ApprovalStatusOnChange() {
      debugger;
      ObjStatusAndApproval.value.ApprovalStatusIds = "";
      const selectedValues = ObjStatusAndApproval.value.ApprovalStatus;

      if (selectedValues && Array.isArray(selectedValues)) {
        const selectedNames: any = [];
        const selectedIds: any = [];

        selectedValues.forEach((selectedValue) => {
          const selectedOption = ApprovalStatusArray.value.find(
            (option) => option.value === selectedValue
          );
          const selectedIdOption = ApprovalStatusArray.value.find(
            (option) => option.value === selectedValue
          );
          if (selectedOption) {
            const selectedName = selectedOption.name;
            selectedNames.push(selectedName);
          }
          if (selectedIdOption) {
            const selectedName = selectedOption?.value;
            selectedIds.push(selectedName);
          }
        });

        console.log("Selected Names:", selectedNames.join(", "));
        if (selectedNames.length > 2) {
          ObjStatusAndApproval.value.ApprovalStatusNames =
            selectedNames.slice(0, 2).join(", ") + ", ...";
        } else {
          ObjStatusAndApproval.value.ApprovalStatusNames =
            selectedNames.join(", ");
        }
        if (selectedIds.length > 0) {
          ObjStatusAndApproval.value.ApprovalStatusIds = selectedIds.join(", ");
        }
        console.log(ObjStatusAndApproval.value.ApprovalStatusIds);
      }
    }

    watch(
      () => props.removechiptype,
      (newVal) => {
        if (newVal == 1) {
          debugger;
          ObjServiceType.value.pocode = "";
        } else if (newVal == 2) {
          ObjServiceType.value.suppliername = "";
          ObjStatusAndApproval.value.SupplierNames = "";
          ObjStatusAndApproval.value.SupplierIds = "";
        } else if (newVal == 3) {
          ObjServiceType.value.poid = "";
          ObjServiceType.value.pocode = "";
          ObjServiceType.value.suppliername = "";
          ObjStatusAndApproval.value.SupplierNames = "";
          ObjStatusAndApproval.value.SupplierIds = "";
          ObjStatusAndApproval.value.StatusNames = "";
          ObjStatusAndApproval.value.StatusIds = "";
          ObjStatusAndApproval.value.Status = "";
        } else if (newVal == 4) {
          ObjServiceType.value.poid = "";
          ObjStatusAndApproval.value.ApprovalStatusIds = "";
          ObjStatusAndApproval.value.ApprovalStatusNames = "";
          ObjStatusAndApproval.value.ApprovalStatus = "";
        }
      }
    );
    function passdata(data) {
      // alert(JSON.stringify(data.value))
      ObjServiceType.value.pocode = data.value.DocNo;
    }

    watch(
      () => ObjServiceType.value.pocode,
      (newVal) => {
        debugger;
        //    alert('s')
        options.value.fromsCodearray = props.itemsList.map((item: any) => {
          item["label"] = item["DocNo"];
          item["value"] = item["DocNo"];
          return item;
        });
      }
    );
    return {
      ObjServiceType,
      options,
      updatedSupplier,
      StatusOnChange,
      // PRStatusArray,
      // POStatusArray,
      // RequestStatusArray,
      // POAmendmentStatusArray,
      ApprovalStatusArray,
      ApprovalStatusOnChange,
      ObjStatusAndApproval,
      StatusArray,
      passdata,
    };
  },
});
</script>

<style lang="scss" scoped></style>
